<template>
  <span class="scaling-svg-container">
    <svg
      id="Icon_receipt"
      xmlns="http://www.w3.org/2000/svg"
      width="9.982"
      height="9.982"
      viewBox="0 0 9.982 9.982"
      class="scaling-svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        id="Fill_1"
        data-name="Fill 1"
        d="M.416,8.319A.416.416,0,0,1,0,7.9V.416A.416.416,0,0,1,.71.122a1.455,1.455,0,0,0,.957.336A1.692,1.692,0,0,0,2,.424,4.973,4.973,0,0,0,2.88.172L2.921.156A2.042,2.042,0,0,1,3.743,0a2.513,2.513,0,0,1,.966.23l.011,0,.01,0a1.78,1.78,0,0,0,.677.178A3.227,3.227,0,0,0,6.184.275C6.47.2,6.75.1,6.916.03a.416.416,0,0,1,.57.386V7.9a.416.416,0,0,1-.6.372A3.852,3.852,0,0,0,5.407,7.9a1.628,1.628,0,0,0-.741.172L4.612,8.1a2,2,0,0,1-.869.22,2.537,2.537,0,0,1-.967-.23l-.01,0-.01,0A1.78,1.78,0,0,0,2.08,7.9a3.347,3.347,0,0,0-.777.141,7.687,7.687,0,0,0-.732.246A.415.415,0,0,1,.416,8.319ZM2.08,7.071a2.512,2.512,0,0,1,.964.229h0l.01,0,.01,0a1.785,1.785,0,0,0,.678.178,1.222,1.222,0,0,0,.548-.156l.02-.009.017-.007a2.44,2.44,0,0,1,1.078-.244,4.224,4.224,0,0,1,1.248.22V1c-.088.028-.169.052-.247.073a3.929,3.929,0,0,1-1,.171,2.543,2.543,0,0,1-.967-.23l-.01,0-.01,0A1.8,1.8,0,0,0,3.743.832a1.242,1.242,0,0,0-.53.1l-.028.01-.011,0a5.749,5.749,0,0,1-1.014.29,2.534,2.534,0,0,1-.5.05,2.4,2.4,0,0,1-.834-.148V7.315c.091-.028.172-.052.247-.073A3.909,3.909,0,0,1,2.08,7.071Z"
        transform="translate(1.248 0.832)"
      />
      <path
        id="Fill_2"
        data-name="Fill 2"
        d="M0,.416A.416.416,0,0,1,.416,0H3.743a.416.416,0,1,1,0,.832H.416A.416.416,0,0,1,0,.416Z"
        transform="translate(2.912 2.912)"
      />
      <path
        id="Fill_3"
        data-name="Fill 3"
        d="M0,.416A.416.416,0,0,1,.416,0H3.743a.416.416,0,1,1,0,.832H.416A.416.416,0,0,1,0,.416Z"
        transform="translate(2.912 4.575)"
      />
      <path
        id="Fill_4"
        data-name="Fill 4"
        d="M0,.416A.416.416,0,0,1,.416,0H2.08a.416.416,0,0,1,0,.832H.416A.416.416,0,0,1,0,.416Z"
        transform="translate(2.912 6.239)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class OrdersIcon extends Vue {}
</script>

<style>
</style>
